import { createSelector, OutputSelector } from 'reselect'
import { ILoadBoardPostsState } from 'types'
import { IStore } from 'apps/booking/utils/reducers'

const selectLoadBoardPosts = (state: IStore): ILoadBoardPostsState => state.loadBoardPosts

interface SelectLoadBoardPostsCount
  extends OutputSelector<
    IStore,
    { count: number },
    (res: ILoadBoardPostsState) => { count: number }
  > {}

export const loadBoardPostsCountSelector: SelectLoadBoardPostsCount = createSelector(
  selectLoadBoardPosts,
  ({ count }) => ({ count })
)
